import OverflowTooltipTypography from "apps/platform-client/client/src/components/OverflowTooltipTypography";

export default function IdColumn(props: { entityId: string; marginLeft?: string }) {
	const { entityId } = props;
	return (
		<OverflowTooltipTypography variant="body2" style={{ marginLeft: props.marginLeft }}>
			{entityId}
		</OverflowTooltipTypography>
	);
}
